import store from 'src/redux/store';
import { setLoggingOut } from 'src/redux/modules/authentication';
import { resetOnboardingState } from 'src/redux/actions/onboardingActions';
import {
  setFlashNotification,
  removePrivateNotifications,
} from 'src/redux/modules/flashNotification';
import { clearUserProfileMetaData } from 'src/redux/actions/questionnaireActions';
import { resetTeleTherapyState } from 'src/redux/actions/teleTherapyActions';
import { resetTodoState } from 'src/redux/actions/todoActions';
import { resetUserIntake } from 'src/redux/modules/userIntake';
import { clearClientResponse } from 'src/redux/modules/questionnaireResponse';
import { Logger } from 'src/latest/src/services';
import Storage from '../latest/src/utils/Storage';
import { clearAccessToken } from 'src/latest/src/auth/authStore';
import { userLogOutV1 } from './user';

export async function GetUserLogOut(
  userId: string,
  type: string,
  showMessage = true,
) {
  store.dispatch(removePrivateNotifications());

  try {
    await userLogOutV1(userId, type);
    store.dispatch(setLoggingOut());
    store.dispatch(resetOnboardingState());
    store.dispatch(clearUserProfileMetaData());
    // ICON-4946: clear remaining PHI-bearing redux state so nothing lingers in memory past logout (teletherapy session/participant data, todo items, intake answers, questionnaire responses).
    store.dispatch(resetTeleTherapyState());
    store.dispatch(resetTodoState());
    store.dispatch(resetUserIntake());
    store.dispatch(clearClientResponse());
    sessionStorage.clear();
    Storage.clear();
    // Storage.clear() doesn't reach authStore's in-memory copy, and logout
    // doesn't reload, so without this the next request still carries it
    clearAccessToken();
  } catch (err) {
    Logger.error(err);
  }

  if (showMessage) {
    store.dispatch(
      setFlashNotification({
        message: 'You have been logged out.',
        duration: 10000,
      }),
    );
  }
}
